export const DIAGNOSIS_SESSION_STORAGE_KEY = 'diagnosis'
export const GROWTHBOOK_EXPERIMENT_DATA_SESSION_STORAGE_KEY = 'growthbookExperimentData'
export const REFRESH_TOKEN_KEY = 'refreshToken'
export const TEXT_FIELD_MIN_LENGTH = 2
export const PASSWORD_FIELD_MIN_LENGTH = 5
